const validExtensions = ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.svg'];
export const validateImageFile = fileName => {
  const extension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
  if (extension && !validExtensions.includes(extension)) {
    return "Invalid file extension. Please upload a ".concat(validExtensions.join(', '), " file.");
  }
};
export const validateRequiredImage = (isRequired, imageType, value) => {
  if (isRequired && !(value !== null && value !== void 0 && value.imageUrl)) {
    return "Upload a ".concat(imageType, " image");
  }
};
export const isValidHttpUrl = url => {
  if (!url) return false;
  const regex = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?(\?[^\s#]*)?(#[^\s]*)?$/i;
  return regex.test(url);
};
const getImageResolution = async blob => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height
      });
    };
    img.onerror = error => {
      reject(error);
    };
    img.src = URL.createObjectURL(blob);
  });
};
export const isImageHavingMinResolution = async (minResolution, imageFile) => {
  if (!minResolution) {
    return true;
  }
  const {
    width,
    height
  } = await getImageResolution(imageFile);
  if (minResolution.width && width < minResolution.width) {
    return false;
  }
  if (minResolution.height && height < minResolution.height) {
    return false;
  }
  return true;
};
export const isImageSizeValid = function isImageSizeValid(file) {
  let maxSizeInMB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  return file.size <= maxSizeInBytes;
};